import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { ProfileState } from '@work-frontend-monorepo/work-ui/state-management';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequiresPermissionService {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next.data['requiredPermission'] && !this.store.selectSnapshot(ProfileState.hasPermission(next.data['requiredPermission']))) {
      // Die fehlende Permission mitgeben, damit die Fehlerseite sie anzeigen kann (sonst ist ein
      // 403 für Support und Entwicklung nicht nachvollziehbar).
      this.router.navigate(['/fehler/403'], { queryParams: { requiredPermission: next.data['requiredPermission'] } }).then();
      return false;
    } else {
      return true;
    }
  }
}

export const RequiresPermissionGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return <boolean>inject(RequiresPermissionService).canActivate(next, state);
};
